// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__7f6Dz","title":"ClientInsurance_title__3iR4c","itemText":"ClientInsurance_itemText__3YX1f"};